import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {DiDate} from 'app/blocks/util/di-date';
import {IContactInfo} from 'app/blocks/model/contact-info.model';
export interface IPerson extends IBaseEntity {
    id?: number;
    firstName?: string;
    lastName?: string;
    dob?: any;
    deleted?: boolean;
    contactInfo?: IContactInfo;
}
export class Person extends BaseEntity implements IPerson {
    public id?: number;
    public firstName?: string;
    public lastName?: string;
    public dob?: any;
    public deleted?: boolean;
    public contactInfo?: IContactInfo;

    constructor(person?) {
        super();
        if (person) {
            this.id = person.id;
            this.firstName = person.firstName;
            this.lastName = person.lastName;
            this.dob = person.dob;
            this.deleted = person.deleted;
            this.contactInfo = person.contactInfo;
        }
    }
    get discriminator(): any {
        return this.firstName;
    }
    clone(): Person {
        return new Person(this);
    }
}
